'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import { getSwanImageUrl } from '../../../core/utilities/manifest-images.utils.js';
import { AlertBoxContext } from './alert-box.context.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { useSwanContext } from '../../contexts/swan-provider/swan-provider.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { useControllableValue } from '../../hooks/use-controllable-value.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(o = 0; o < s.length; o++)r = s[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, s = Object.keys(e);
    for(o = 0; o < s.length; o++)r = s[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const AlertBox = renderWithRef('AlertBox', null, (s, u)=>{
    useComponentStylesLoaded('AlertBox', SWAN_STYLE_KEY_MAP.alertBox), useDeprecatedProps('AlertBox', s, [
        {
            propName: 'skin',
            deprecatedValues: {
                standard: 'Use skin="info" instead.',
                positive: 'Use skin="success" instead.'
            }
        },
        {
            propName: 'width',
            instructions: 'To maintain consistent user experience `width` is deprecated without a replacement.'
        }
    ]);
    let { swanPathType: d, swanBaseUrl: b } = useSwanContext(), { skin: f = 'info', width: m = 'standard', toast: w = false, children: O, accessibleTextForIcon: _, dismissed: j, onRequestDismiss: y } = s, g = _object_without_properties(s, [
        "skin",
        "width",
        "toast",
        "children",
        "accessibleTextForIcon",
        "dismissed",
        "onRequestDismiss"
    ]), [h, x] = useControllableValue({
        value: j,
        onChange: y || void 0,
        defaultValue: false,
        defaultOnChange: (e)=>{
            e(true);
        }
    });
    if (h) return null;
    let v = new Set([
        'swan-vanilla-ignore',
        'swan-alert-box'
    ]);
    f && 'info' !== f && 'standard' !== f && v.add(`swan-alert-box-skin-${f}`), 'narrow' === m && v.add("swan-alert-box-narrow"), w && v.add("swan-alert-box-toast");
    let P = getSwanImageUrl('legalWarning', d, b), k = {};
    return _ && (k = {
        role: 'img',
        'aria-label': _
    }), jsx(AlertBoxContext.Provider, {
        value: {
            onRequestDismiss: x
        },
        children: jsxs(RenderComp, {
            root: "div",
            forwardedRef: u,
            classNames: v,
            props: _object_spread_props(_object_spread({}, g), {
                role: 'alert'
            }),
            children: [
                'legal-warning' === f && P ? jsx("img", {
                    src: P,
                    alt: _ || ''
                }) : jsx("span", _object_spread_props(_object_spread({}, k), {
                    className: `swan-alert-box-icon swan-alert-box-icon-${f}`
                })),
                O
            ]
        })
    });
});

export { AlertBox };
